export function SkeletonCard() {
  return (
    <div className="animate-pulse p-4 mc-panel">
      <div className="h-6 bg-muted-foreground/20 mb-3 w-2/3"></div>
      <div className="h-4 bg-muted-foreground/20 mb-2"></div>
      <div className="h-4 bg-muted-foreground/20 w-5/6"></div>
    </div>
  );
}

export function SkeletonField() {
  return (
    <div className="space-y-2 animate-pulse">
      <div className="h-4 bg-muted-foreground/20 w-1/4"></div>
      <div className="h-10 bg-muted-foreground/20"></div>
    </div>
  );
}

export function SkeletonText({ lines = 3 }: { lines?: number }) {
  return (
    <div className="space-y-2 animate-pulse">
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className={`h-4 bg-muted-foreground/20 ${i === lines - 1 ? "w-5/6" : "w-full"}`}></div>
      ))}
    </div>
  );
}
